import { Stack, Typography } from "@mui/material"
import { useFormikContext } from "formik";
import { OnboardingFormValues } from "../Onboarding";
import ImageUpload from "@/components/ImageUpload";

const getIndustryName = (id: string) => {
    switch (id) {
        case 'restaurant':
            return 'Restaurante';
        case 'other':
            return 'Comercio';
        default:
            return 'Restaurante';
    }
}

const OrganizationNameStep = () => {
    const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();

    return (
        <Stack spacing={3}>
            <Typography textAlign="center" variant="h1" color="white">
                {`Carga el logotipo de tu ${getIndustryName(values.industry)}`}
            </Typography>
            <Stack
                direction="row"
                spacing={3}
                justifyContent="center"
                sx={{
                    '& .image-upload>.MuiTypography-root': {
                        color: 'white'
                    }
                }}
            >
                <ImageUpload
                    label="Logotipo"
                    value={values.logo}
                    onChange={(file) => setFieldValue('logo', file)}
                />
                <ImageUpload
                    label="Isotipo"
                    value={values.isotype}
                    onChange={(file) => setFieldValue('isotype', file)}
                />
            </Stack>
        </Stack>
    )
}

export default OrganizationNameStep;
